export function PersonCard(data, hover='bg') {
    return `<div class="person-card bg-hover-${hover}">
        <a class="person-card__link" href="${data.Link}">
            <div class="person-card__photo">
                <img loading="lazy" src="${data.Image}" alt="${data.Name}">
            </div>
            <h3 class="serif">${data.Name}</h3>
            <h4>${data.Role} - ${data.Office}</h4>
        </a>
    </div>`;
}
